import axios from 'axios';

export const getMyUserInfo = () => axios.get('/v1/private/users/my');
export const createCollection = (form) => axios.post('/v1/private/collections', form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateCollection = (collectionId, form, language) => axios.put(`/v1/private/collections/${collectionId}/${language}`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateCollectionCells = (collectionId, cells) => axios.put(`/v1/private/collections/${collectionId}/cells`, { cells });
export const updateProfile = (form) => axios.put('/v1/private/users/my', form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateUserMobile = (mobile) => axios.put('/v1/private/users/my/mobile', { mobile });
export const createProfile = (title) => axios.post('/v1/private/users/my/profiles', { title });
export const deleteProfile = (profileId) => axios.delete(`/v1/private/users/my/profiles/${profileId}`);
export const updateProfileVisibility = (visibleProfileIds) => axios.put('/v1/private/users/my/profiles/visibility', { visibleProfileIds });
export const updateProfileContent = (profileId, content) => axios.put(`/v1/private/users/my/profiles/${profileId}`, { content });
export const removeCollection = (collectionId) => axios.post('/v1/private/collection/delete', { collectionId });
export const updateTempCollection = (collectionId, form) => axios.put(`/v1/private/collections/${collectionId}/temp`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const createDraftCollection = (collectionId, form) => axios.put(`/v1/private/collections/${collectionId}/draft`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateCollectionOrders = (collectionIds) => axios.put('/v1/private/collections/order', { collectionIds });

/**
 * @deprecated 예전 멤버쉽 API 입니다. 서버에서 더 이상 지원하지 않습니다.
 */
export const registerMembership = (code) => axios.post('/v1/private/register', { code });
export const getNotice = () => axios.get('/v1/private/notices');
export const deleteNotice = (noticeId) => axios.delete(`/v1/private/notices/${noticeId}`);
export const toggleLikeCollection = (collectionId) => axios.post(`/v1/private/collection/${collectionId}/like`);
export const getLikeCollection = (collectionId) => axios.get(`/v1/private/collection/${collectionId}/like`);
export const followUser = (userId) => axios.post(`/v1/private/users/${userId}/follow`);
export const unfollowUser = (userId) => axios.delete(`/v1/private/users/${userId}/follow`);
export const getFollowStatus = (userId) => axios.get(`/v1/private/users/${userId}/follow`);
export const getFollowingList = () => axios.get('/v1/private/users/followings');
export const getFollowerList = () => axios.get('/v1/private/users/followers');
export const readNotice = (noticeId) => axios.patch(`/v1/private/notices/${noticeId}/read`);

// 컬렉션에 셀 추가
export const addCellToCollection = (collectionId, cellId) => axios.post(`/v1/private/collection/${collectionId}/cells/add/${cellId}`);

export const createCustomCell = (customCell) => axios.post('/v1/private/cell', customCell, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateCustomCell = (cellId, customCell, language) => axios.put(`/v1/private/cell/${cellId}/${language}`, customCell, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteCustomCell = (cellId) => axios.delete(`/v1/private/cell/${cellId}`);
export const updateTempCell = (cellId, customCell) => axios.put(`/v1/private/cell/${cellId}/temp`, customCell, { headers: { 'Content-Type': 'multipart/form-data' } });
export const createDraftCell = (cellId, customCell) => axios.put(`/v1/private/cell/${cellId}/draft`, customCell, { headers: { 'Content-Type': 'multipart/form-data' } });

// 셀 히스토리 목록 조회
export const getCellHistory = (skip, limit) => axios.get('/v1/private/cells/history', { params: { skip, limit } });

// 내가 본 컬렉션 조회
export const getCollectionHistory = (skip, limit) => axios.get('/v1/private/collections/history', { params: { skip, limit } });

// 사용자 챗 보내기
export const sendUserChat = (userId, content) => axios.post(`/v1/private/users/${userId}/chat`, { content });

// 독자 응원글 보내기
export const sendUserCheers = (userId, content) => axios.post(`/v1/private/users/${userId}/cheers`, { content });

// 당신과 비슷한 취향인
export const getUserRelated = (userId, limit) => axios.get('/v1/private/users/related', { params: { userId, limit } });

// 지식톡에 컬렉션 추가
export const addCollectionToJisikTalk = (jisikTalkId, collectionId) => axios.post(`/v1/private/togethers/${jisikTalkId}/subject/${collectionId}`);

// 지식톡에 추가된 컬렉션 삭제
export const deleteCollectionToJisikTalk = (jisikTalkId, collectionId) => axios.delete(`/v1/private/togethers/${jisikTalkId}/subject/${collectionId}`);

// 부적절 내용 신고
export const reportIllegalContent = (type, id, reason) => axios.post('/v1/private/reports', { type, id, reason });

// 지식톡 삭제
export const deleteTalk = (talkId) => axios.delete(`/v1/private/togethers/${talkId}`);

// 메모 생성
// export const createMemos = (target, targetId, content, keywords, rate, type, isPublic, color) => axios.post('/v1/private/memos', { target, targetId, content, keywords, rate, type, isPublic, color });

// 메모 수정
// export const updateMemos = (id, isPublic, content, keywords, rate, color) => axios.put(`/v1/private/memos/${id}`, { isPublic, content, keywords, rate, color });
export const createMemos = (formData, orgKey) => {
  // orgKey가 있으면 formData에 추가
  if (orgKey) {
    formData.append('orgKey', orgKey);
  }
  return axios.post('/v1/private/memos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateMemos = (id, formData) => axios.put(`/v1/private/memos/${id}`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 메모 조회
export const getMyMemoList = () => axios.get('/v1/private/memos/my');

// 메모 키워드 조회
export const getMemoKeywordList = () => axios.get('/v1/private/memos/keywords/my');

// 메모 상세 조회
export const getMemoDetail = (id) => axios.get(`/v1/private/memos/${id}`);

// 메모 삭제
export const deleteMemo = (memoId) => axios.delete(`/v1/private/memos/${memoId}`);

// 메모 댓글 등록
export const sendMemoChat = (memoId, content, isAiQuestion) => axios.post(`/v1/private/memos/${memoId}/messages`, { isAiQuestion, content });

// 메모 댓글 삭제
export const deleteMessage = (messageId) => axios.delete(`/v1/private/messages/${messageId}`);

// 대댓글 등록
export const replyMessage = (messageId, content, mention) => axios.post(`/v1/private/messages/${messageId}/replies`, { mention, content });

// 회원 탈퇴
export const deleteMyAccountApi = () => axios.delete('/v1/private/users/my');

// 등록 가능한 기관 코드 조회
export const getCodeAvailable = () => axios.get('/v1/private/organizations/codes/available');

// 기관 코드 등록
export const registerCode = (organizationCode, code) => axios.post(`/v1/private/organizations/${organizationCode}/codes/${code}`);

// 기관에 소속되기
export const followOrganization = (code) => axios.post(`/v1/private/organizations/codes/${code}/follow`);

// 포인트 충전 시도하기
export const tryCharge = (tryAmount, subsPeriodYear, organizationId, subsPeople) => axios.post('/v1/private/users/my/points/charge', { tryAmount, subsPeriodYear, organizationId, subsPeople });

// 회원 유효기간 조회
export const getSubscriptionPeriod = () => axios.get('/v1/private/users/my/subscription');

// 메모 좋아요
export const toggleLikeMemo = (memoId) => axios.post(`/v1/private/memos/${memoId}/like`);

// 내가 알 수 도 있는 사용자 목록 조회
export const getYouMayKnowList = (skip = 0, limit = 10) => axios.get(`/v1/private/users/you-may-know?skip=${skip}&limit=${limit}`);

// 나와 관련된 사람 검색
export const getMyPeople = (keyword) => axios.get('/v1/private/users/my-people', { params: { keyword } });

// 인텔즈를 사용하지 않는 사용자 조회
export const getNotIntelzerList = (skip = 0, limit = 10) => axios.get(`/v1/private/users/not-intelzer?skip=${skip}&limit=${limit}`);

// 내 이익 조회
export const getMyBenefit = () => axios.get('/v1/private/users/my/benefit');

// 내 결제 내역 조회
export const getMySubscriptions = () => axios.get('/v1/private/users/my/subscriptions');

// 기관 결제 내역 조회
export const getOrgSubscriptions = () => axios.get('/v1/private/organizations/my/subscriptions');

// 기관에 속한 회원 조회
export const getOrgMembers = () => axios.get('/v1/private/organizations/my/members');

// 기관에 속한 회원 삭제
export const deleteOrgMembers = (userIds) => axios.delete('/v1/private/organizations/my/members', { data: { userIds } });

// 지식북 요청
export const createBanner = (title, content, color) => axios.post('/v1/private/questions', { title, content, color });

// 지식북 요청 수정
export const editBanner = (questionId, title, content, color) => axios.put(`/v1/private/questions/${questionId}`, { title, content, color });

// 지식북 요청 삭제
export const deleteBanner = (id) => axios.delete(`/v1/private/questions/${id}`);

// 지식북 요청 답변 등록 (관리자만 가능)
export const writeBannerAnswer = (questionId, answer) => axios.post(`/v1/private/questions/${questionId}/answers`, { answer });

// 지식북 요청 답변 수정 (관리자만 가능)
export const editBannerAnswer = (answerId, answer) => axios.put(`/v1/private/questions/answers/${answerId}`, { answer });

// 지식북 요청 답변 삭제
export const deleteBannerAnswer = (answerId) => axios.delete(`/v1/private/questions/answers/${answerId}`);

// 지식북 요청에 컬렉션 연결
export const addCollectionToBanner = (questionId, collectionIds) => axios.post(`/v1/private/questions/${questionId}/related-collections`, { collectionIds });

// 유료로 출판할 수 있는지 체크하는 API
export const canMakePaid = (collectionId) => axios.get(`/v1/private/collections/${collectionId}/can-make-paid`);

// 양도할 수 있는지 체크하는 API
export const canTransfer = (collectionId) => axios.get(`/v1/private/collections/${collectionId}/can-transfer`);

// 미니북 출판
export const requestPublishBook = (collectionId, price, currency, publishStartAt, publishEndAt, sponsorable) => axios.post(`/v1/private/collections/${collectionId}/publish-request`, { price, currency, publishStartAt, publishEndAt, sponsorable });

// 미니북 구매
export const purchaseBook = (collectionId, currency, tryAmount, language) => axios.post(`/v1/private/collections/${collectionId}/purchase`, { currency, tryAmount, language });

// 미니북 후원결제
export const sponsorBook = (collectionId, currency, tryAmount, language, giftItem, message) => axios.post(`/v1/private/collections/${collectionId}/sponsor`, { currency, tryAmount, language, giftItem, message });

// 이벤트 구매
export const purchaseEvent = (eventId, currency, tryAmount) => axios.post(`/v1/private/events/${eventId}/purchase`, { tryAmount, currency });

// 구매이력 조회
export const getMyPurchaseList = () => axios.get('/v1/private/users/my/purchases');

// 구매한 이벤트 조회
export const getMyPurchaseEventList = () => axios.get('/v1/private/users/my/participants');

// 계좌정보 입력/수정
export const saveMyAccount = (values) => axios.put('/v1/private/users/my/account-info', values);

// 내 계좌 조회
export const getMyAccount = () => axios.get('/v1/private/users/my/account-info');

// 투게더 공지 등록
export const createTogetherNotice = (togetherId, title, content) => axios.post(`/v1/private/togethers/${togetherId}/notices`, { title, content });

// 투게더 공지 수정
export const editTogetherNotice = (togetherId, noticeId, title, content) => axios.put(`/v1/private/togethers/${togetherId}/notices/${noticeId}`, { title, content });

// 투게더 공지 삭제
export const deleteTogetherNotice = (togetherId, noticeId) => axios.delete(`/v1/private/togethers/${togetherId}/notices/${noticeId}`);

// 서버에 이미지 업로드
export const uploadImgToServer = (image) => axios.post('/v1/private/image', image, { headers: { 'Content-Type': 'multipart/form-data' } });

// 출판권을 소유한 미니북 조회
export const getHavePublishingRight = (isPublished) => axios.get('/v1/private/collections/have-publishing-right', { params: { isPublished } });

// 출판권 양도
export const transferPublishingRight = (collectionId, assignees) => axios.post(`/v1/private/collections/${collectionId}/publishing-right`, { assignees });

// 수익이 발생한 미니북 목록 조회
export const getHaveEarnings = () => axios.get('/v1/private/collections/have-earnings');

// 정산내역 조회
export const getMySettlementList = (collectionId, language, year, half) => axios.get('/v1/private/users/my/settlements/collections', { params: { collectionId, language, year, half } });

// 이벤트 정산내역 조회
export const getMyEventSettlementList = (eventId, year, half) => axios.get('/v1/private/users/my/settlements/events', { params: { eventId, year, half } });

// 아임포트 결제 내역 조회
export const getIamportPaymentDetails = (impUid) => axios.get(`/v1/private/iamport/payments/${impUid}`);

// 특정 미니북, 언어에 대해 정산받을 계좌 타입 수정
export const editAccountType = (settleWithCorporateAccount) => axios.put('/v1/private/users/my/settlement-account', { settleWithCorporateAccount });

// 미니북에 대한 판매량 조회
export const getStatisticsSales = (collectionId, language, periodInMonths) => axios.get('/v1/private/statistics/collections/sales', { params: { collectionId, language, periodInMonths } });

// 미니북에 대한 독자수 조회
export const getStatisticsReaders = (collectionId, language, periodInMonths) => axios.get('/v1/private/statistics/collections/readers', { params: { collectionId, language, periodInMonths } });

// 이벤트에 대한 판매량 조회
export const getEventStatisticsSales = (eventId, periodInMonths) => axios.get('/v1/private/statistics/events/sales', { params: { eventId, periodInMonths } });

// 미니북에 대한 광고 시청수 조회
export const getStatisticsRents = (collectionId, language, periodInMonths) => axios.get('/v1/private/statistics/collections/rents', { params: { collectionId, language, periodInMonths } });

// 광고 시청후 미니북 보기 허용
export const showMiniBookAfterAd = (collectionId, language) => axios.post(`/v1/private/collections/${collectionId}/rent`, { language });

// 오픈 미니북 저자 신청하기
export const requestOwner = (collectionId, message) => axios.post(`/v1/private/collections/${collectionId}/request-owner`, { message });

// 오픈 미니북 저자 수락/거절
export const approveRejectOwner = (collectionId, requesterId, action) => axios.put(`/v1/private/collections/${collectionId}/owners/${requesterId}`, { action });

// 오픈 미니북 저자 신청 목록
export const getOwnerRequesterList = (collectionId) => axios.get(`/v1/private/collections/${collectionId}/owner-requesters`);

// 공저자 메시지 보내기
export const sendOwnersChat = (collectionId, content) => axios.post(`/v1/private/collections/${collectionId}/owner-messages`, { content });

// 공저자 메시지 조회
export const getOwnersChatList = (collectionId) => axios.get(`/v1/private/collections/${collectionId}/owner-messages`);

// medium 페이지 import
export const importMedium = (file) => axios.post('/v1/private/import/medium/zip', file, { headers: { 'Content-Type': 'multipart/form-data' } });

// substack 페이지 import
export const importSubstack = (file) => axios.post('/v1/private/import/substack/zip', file, { headers: { 'Content-Type': 'multipart/form-data' } });

// 미니북 금액 수정
export const editPrice = (collectionId, price) => axios.put(`/v1/private/collections/${collectionId}/price`, { price });

// 사용자 핸들 중복체크
export const verifyHandle = (handle) => axios.post('/v1/auth/verify-handle', { handle });

// 사용자 핸들 수정
export const editHandle = (handle) => axios.put('/v1/private/users/my/handle', { handle });

// 관리자: 사용자 카테고리 업데이트
export const updateUserCategory = (userId, category) => axios.put(`/v1/admin/users/${userId}/category`, { category });

// 오픈미니북 신청
export const applyToOpenMinibook = (collectionId) => axios.post(`/v1/private/collections/${collectionId}/open`);

// 오픈미니북 취소
export const cancelOpenMinibook = (collectionId) => axios.post(`/v1/private/collections/${collectionId}/close`);

// 작가 응원하기
export const cheerAuthor = (userId) => axios.post(`/v1/private/cheers/to/${userId}`);

// 내가 작가의 응원자인지 체크
export const getCheerStatus = (userId) => axios.get(`/v1/private/cheers/to/${userId}/status`);

// 내가 응원하는 사람 목록 조회
export const getCheeringList = () => axios.get('/v1/private/users/my/cheering');

// 나를 응원하는 사람 목록 조회
export const getCheeredByList = () => axios.get('/v1/private/users/my/cheered-by');

// 나를 응원하는 사람 삭제
export const deleteCheeredBy = (userId) => axios.delete(`/v1/private/cheers/from/${userId}`);

// 내가 응원하는 사람 삭제
export const deleteCheering = (userId) => axios.delete(`/v1/private/cheers/to/${userId}`);

// (문자 보내기 에서) 내 친구들 조회
export const getMyFriendsViaSMS = (contentType, userId, labelId, skip, limit) => axios.get('/v1/private/phone-contacts', { params: { contentType, userId, labelId, skip, limit } });

// (문자 보내기 에서) 내 팔로워 조회
export const getMyFollowersViaSMS = (contentType, userId, skip, limit) => axios.get('/v1/private/users/followers/phones', { params: { contentType, userId, skip, limit } });

// (이메일 보내기 에서) 내 친구들 조회
export const getMyFriendsViaEmail = (contentType, userId, labelId, skip, limit, keyword) => axios.get('/v1/private/email-contacts', { params: { contentType, userId, labelId, skip, limit, keyword } });

// (이메일 보내기 에서) 내 팔로워 조회
export const getMyFollowersViaEmail = (contentType, userId, skip, limit) => axios.get('/v1/private/users/followers/emails', { params: { contentType, userId, skip, limit } });

// 이메일 또는 SMS 전송
export const sendPromotion = ({
  contentType,
  contentId,
  via,
  recipients,
  isSelectAll,
  excludedRecipients,
  labelId,
  title,
  message,
  topic,
  link,
}) => {
  const recipient = isSelectAll
    ? {
      labelId: labelId || 'all', // default to 'all' if not provided
      exclude: excludedRecipients,
    }
    : {
      recipients,
    };

  return axios.post('/v1/private/acon-promotions/send', {
    contentType,
    contentId,
    via,
    recipient,
    title,
    message,
    topic,
    link,
  });
};

// SMS 업로드
export const importSMS = (file) => axios.post('/v1/private/phone-contacts', file, { headers: { 'Content-Type': 'multipart/form-data' } });

// SMS 라벨 목록 조회
export const getSMSLabels = () => axios.get('/v1/private/phone-labels');

// SMS 연락처 삭제
export const deleteSMS = (contactIds) => axios.delete('/v1/private/phone-contacts', { data: { contactIds } });

// SMS 연락처 조회
export const getSMSInfo = (contactId) => axios.get(`/v1/private/phone-contacts/${contactId}`);

// SMS 연락처 수정
export const updateSMSContact = (contactId, contactInfo) => axios.patch(`/v1/private/phone-contacts/${contactId}`, contactInfo);

// SMS 라벨 생성
export const createSMSLabel = (name) => axios.post('/v1/private/phone-labels', { name });

// SMS 라벨 삭제
export const deleteSMSLabel = (labelId) => axios.delete(`/v1/private/phone-labels/${labelId}`);

// SMS 라벨 수정
export const updateSMSLabel = (labelId, name) => axios.patch(`/v1/private/phone-labels/${labelId}`, name);

// email 업로드
export const importEmail = (file) => axios.post('/v1/private/email-contacts', file, { headers: { 'Content-Type': 'multipart/form-data' } });

// 이메일 라벨 목록 조회
export const getEmailLabels = () => axios.get('/v1/private/email-labels');

// 이메일 연락처 삭제
export const deleteEmail = (contactIds) => axios.delete('/v1/private/email-contacts', { data: { contactIds } });

// 이메일 연락처 조회
export const getEmailInfo = (contactId) => axios.get(`/v1/private/email-contacts/${contactId}`);

// 이메일 연락처 생성
export const createEmailContact = (contactInfo) => axios.post('/v1/private/email-contacts', contactInfo);

// 이메일 연락처 수정
export const updateEmailContact = (contactId, contactInfo) => axios.patch(`/v1/private/email-contacts/${contactId}`, contactInfo);

// 이메일 라벨 생성
export const createEmailLabel = (name) => axios.post('/v1/private/email-labels', { name });

// 이메일 라벨 삭제
export const deleteEmailLabel = (labelId) => axios.delete(`/v1/private/email-labels/${labelId}`);

// 이메일 라벨 수정
export const updateEmailLabel = (labelId, name) => axios.patch(`/v1/private/email-labels/${labelId}`, name);

// 주소록 단건 생성
export const createAconContact = (contactData) => axios.post('/v1/private/acon-contacts', contactData);

// 프로필 비디오 링크 추가
export const addVideoLinks = (url) => axios.post('/v1/private/users/my/video-links', { url });

// 프로필 소셜 링크 추가
export const addSocialLinks = (url) => axios.post('/v1/private/users/my/social-links', { url });

// 비디오 링크 수정
export const updateVideoLink = (linkId, url) => axios.put(`/v1/private/users/my/video-links/${linkId}`, { url });

// 비디오 링크 삭제
export const deleteVideoLink = (linkId) => axios.delete(`/v1/private/users/my/video-links/${linkId}`);

// 소셜 링크 수정
export const updateSocialLink = (linkId, url) => axios.put(`/v1/private/users/my/social-links/${linkId}`, { url });

// 소셜 링크 삭제
export const deleteSocialLink = (linkId) => axios.delete(`/v1/private/users/my/social-links/${linkId}`);

// 주소록 관련 API들

// 연락처 업로드 - Acon 전용
export const uploadContacts = (file) => axios.post('/v1/private/acon-contacts/phone-numbers', file, { headers: { 'Content-Type': 'multipart/form-data' } });

// 앱에서 주소록 자동 동기화 (전화번호 기반) TODO: 사용하는 곳 확인 필요
export const syncAconContactsByPhone = (contactData) => axios.post('/v1/private/acon-contacts/phone-numbers', contactData);

// CSV, VCF 파일 업로드로 주소록 동기화
export const syncAconContactsByFile = (file) => axios.post('/v1/private/acon-contacts/file', file, { headers: { 'Content-Type': 'multipart/form-data' } });

// 주소록 라벨 조회
export const getContactLabels = () => axios.get('/v1/private/contact-labels');

// 주소록 전체 조회 (via 파라미터로 email 또는 phone 지정 가능)
export const getContacts = (via, contentType, userId, labelId, skip, limit, keyword) => axios.get('/v1/private/contacts', { params: { via, contentType, userId, labelId, skip, limit, keyword } });

// 주소록 한건 조회
export const getContact = (contactId) => axios.get(`/v1/private/contacts/${contactId}`);

// 주소록 수정
export const updateContact = (contactId, contactData) => axios.put(`/v1/private/contacts/${contactId}`, contactData);

// 주소록 삭제
export const deleteContacts = (contactIds) => axios.delete('/v1/private/contacts', { data: { contactIds } });

// 연락처 라벨 생성
export const createContactLabel = (name) => axios.post('/v1/private/contact-labels', { name });

// 연락처 라벨 수정
export const updateContactLabel = (labelId, name) => axios.put(`/v1/private/contact-labels/${labelId}`, { name });

// 연락처 라벨 삭제
export const deleteContactLabel = (labelId) => axios.delete(`/v1/private/contact-labels/${labelId}`);

// 소개영상 업데이트
export const updateIntroVideo = (url) => axios.put('/v1/private/users/my/intro-video', { url });

// 성별 업데이트 (관리자)
export const updateUserGender = (userId, gender) => axios.put(`/v1/admin/users/${userId}/gender`, { gender });

// 디지털 쌍둥이 1분 사용량 기록
export const recordDigitalTwinUsage = (digitalTwinId) => axios.post(`/v1/private/digital-twin/stream/${digitalTwinId}/usage/minute`);

// 디지털 쌍둥이 무료 추가 대화 시간 요청
export const requestFreeExtension = (digitalTwinId) => axios.post(`/v1/private/digital-twin/stream/${digitalTwinId}/extension-limit`);

// 대화/강의 결제 요청 API (POST /v1/private/payments/entitlements)
// additionalData에 아래를 넣으면 기관 지원 요청으로 처리:
//   isFundingRequested, justification, requesterName, requesterOrganization,
//   requesterEmail, requesterPhone, requesterAddress
// VIDEO_LECTURE 시: lectureStyle, lectureHours
export const requestEntitlementPayment = (type, targetUserId, currency, tryAmount, giftItem, message, orgKey, additionalData = {}) => axios.post('/v1/private/payments/entitlements', {
  type,
  targetUserId,
  currency,
  tryAmount,
  giftItem,
  message,
  orgKey,
  ...additionalData,
});

// 강의 가격 수정
export const updateLecturePrices = (lecturePrices) => axios.patch('/v1/private/users/my/lecture-prices', lecturePrices);

// 강의 공지사항 수정
export const updateLectureNotice = (lectureNotice) => axios.patch('/v1/private/users/my/lecture-notice', lectureNotice);

// 기관 좋아요 토글
export const toggleOrganizationLike = (key) => axios.post(`/v1/private/organizations/${key}/like`);

// 강의료 지원 요청 목록 조회 (전체 목록, 페이징은 프론트에서)
export const getFundingRequests = (orgKey) => axios.get(
  `/v1/private/organizations/${orgKey}/funding-requests`,
);

// 강의료 지원 확정하기 (status: APPROVED | REJECTED, reason/noticedAt/memo 옵셔널)
export const patchFundingRequestStatus = (orgKey, requestId, body) => axios.patch(
  `/v1/private/organizations/${orgKey}/funding-requests/${requestId}/status`,
  body,
);

// 강의료 지원 신청내역 정보 수정 (reason, noticedAt, memo)
export const patchFundingRequestDetails = (orgKey, requestId, body) => axios.patch(
  `/v1/private/organizations/${orgKey}/funding-requests/${requestId}/details`,
  body,
);

// 강의료 결제 목록 조회
export const getPaymentList = (orgKey) => axios.get(
  `/v1/private/organizations/${orgKey}/payments`,
);

// 결제 주기 조회 (샘플 - 실제 API 구현 전)
export const getPaymentDate = (orgKey) => axios.get(
  `/v1/private/organizations/${orgKey}/payment-date`,
);

// 강의료 결제정보 조회 (결제일, 미결제액)
export const getPaymentInfo = (orgKey) => axios.get(
  `/v1/private/organizations/${orgKey}/payment-info`,
);

// 결제 주기 지정
export const updatePaymentDate = (orgKey, paymentDate) => axios.put(
  `/v1/private/organizations/${orgKey}/payment-date`,
  { paymentDate },
);

// 강의료 결제
export const purchasePayment = (orgKey, body) => axios.post(
  `/v1/private/organizations/${orgKey}/purchase`,
  body,
);

// 기관 문제 유형 선택 (main-type 업데이트)
export const updateOrganizationMainType = (key, mainType) => axios.put(`/v1/private/organizations/${key}/main-type`, { mainType });

// 기관 사업자등록증 파일 업로드
export const uploadOrganizationFile = (orgKey, file) => axios.post(
  `/v1/private/organizations/${orgKey}/file`,
  file,
  { headers: { 'Content-Type': 'multipart/form-data' } },
);

// 기관 properties 업데이트 (사업자등록증 URL 저장)
export const updateOrganizationProperties = (orgKey, properties) => axios.patch(
  `/v1/private/organizations/${orgKey}/properties`,
  properties,
);

// 기관 영상 구매자 목록 조회
export const getVideoPurchases = (orgKey) => axios.get(
  `/v1/private/organizations/${orgKey}/video-purchases`,
);

// 동영상 강의 업로드
export const createRecordedLecture = (payload) => axios.post(
  '/v1/private/recorded-lectures',
  payload,
);

// 동영상 강의 수정
export const updateRecordedLecture = (id, payload) => axios.put(
  `/v1/private/recorded-lectures/${id}`,
  payload,
);

// 동영상 강의 구매
export const purchaseRecordedLecture = (id, tryAmount) => axios.post(
  `/v1/private/recorded-lectures/${id}/purchase`,
  { tryAmount },
);

// 동영상 강의 삭제
export const deleteRecordedLecture = (id) => axios.delete(
  `/v1/private/recorded-lectures/${id}`,
);

// 디지털 쌍둥이 음성 대화 스크립트 조회
export const getDigitalTwinScript = (digitalTwinId, clientTimezone, mode) => axios.get(`/v1/private/digital-twin/${digitalTwinId}/script`, { params: { clientTimezone, mode } });

// 디지털 쌍둥이 채팅 대화 기록 조회
export const getChatHistory = (digitalTwinUserId) => axios.get(`/v1/private/digital-twin/${digitalTwinUserId}/chat-history`);

// Gemini Live API 임시 토큰 발급
export const getGeminiLiveToken = () => axios.post('/v1/private/ai/gemini-live/token');
